export default function StatusLabel({ data }) {
  return (
    <div
      className="py-1 px-2 rounded-md max-w-min"
      style={{ backgroundColor: data.bgColor, color: data.color }}
    >
      {data.label}
    </div>
  );
}
